export const guideChatCreateMessage = '/guide/chat/';
